'use strict';

import { Entity } from '../Entity';

export class UserBlitz extends Entity {
  protected id;

  protected user;

  protected criteria = [];

  protected data = [];

  protected currentIndex;

  protected lastUpdateTime;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.user = data.user;

    this.criteria = data.criteria;

    this.data = data.data;

    this.currentIndex = data.currentIndex;

    if (data.lastUpdateTime) {
      const lastUpdateTimeDate = data.lastUpdateTime.date.split(' ')[0].split('-');
      const dateTimeCreatedTime = data.lastUpdateTime.date.split(' ')[1];

      this.lastUpdateTime =
        lastUpdateTimeDate[1] + '/' + lastUpdateTimeDate[2] + '/' + lastUpdateTimeDate[0];
    }
  }

  public getId() {
    return this.id;
  }

  public getUser() {
    return this.user;
  }

  public getCriteria() {
    return this.criteria;
  }

  public getData() {
    return this.data;
  }

  public getCurrentIndex() {
    return this.currentIndex;
  }

  public getLastUpdateTime() {
    return this.lastUpdateTime;
  }
}
